/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

export const AIGC_PROXY_HOST = 'https://svc.googoome.com/api/rtc/doubao/chat:start';
